import { SHARED_REACT_QUERY_CONFIG } from "../../constants/reactQuery.constant";
import { getSelfInspectionsAPI } from "../../services/selfInspection/selfInspection.service";

export const SELF_INSPECTIONS_QUERY = "selfInspections";
export const SELF_INSPECTIONS_QUERY_CONFIG = SHARED_REACT_QUERY_CONFIG;

export const selfInspectionsQuery = async ({ pageParam = 1}) => {
  const request = await getSelfInspectionsAPI(pageParam);
  return request.data;
};
